import {ERRORS_SET, ERRORS_RESET} from './actions';

const errors = (state = {errors: null}, action) => {
  switch (action.type) {
    case ERRORS_SET:
        return {
            errors: {
                message: action.payload.message,
            }
        }
    case ERRORS_RESET:
        return {
            errors: null,
        }
    default:
      return state;
  }
}

export default errors;


// WEBPACK FOOTER //
// ./src/errors/reducer.js